//#region OldCode before Address and Zip
// import * as React from "react";
// import Input from "../Input-new/Input";
// import Dropdown from "../Dropdown/Dropdown";

// const LenderInfo = ({ data, handleChangeInput,handleChangeDropdown, viewMode, deleted }) => {
//     return (
//         <div className="Lender-info">
//             <div className="Lender-info_column">
//                 <Input
//                     className="Lender-info_column_item"
//                     required
//                     valueType="text"
//                     //name="NAME"
//                     name="name"
//                     label="LENDER NAME"
//                     //value={data.NAME}
//                     value={data.name}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />
//                 <Input
//                     className="Lender-info_column_item"
//                     valueType="text"
//                     //name="CITY"
//                     name="city"
//                     label="CITY"
//                     //value={data.CITY}
//                     value={data.city}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />

//                 <Dropdown
//                     className="Lender-info_column_item"
//                     data={data}
//                     optionsType="states"
//                     optionKey="abbr"
//                     optionLabelKey="name"
//                     // value={data.STATE}
//                     // valueKey="STATE"
//                     value={data.state}
//                     valueKey="state"
//                     label="STATE"
//                     handleParentChange={handleChangeDropdown}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />
//                 <Input
//                     className="Lender-info_column_item"
//                     valueType="text"
//                     //name="CONTACT_NAME"
//                     name="contact_name"
//                     label="CONTACT NAME"
//                     //value={data.CONTACT_NAME}
//                     value={data.contact_name}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />
//                 <Input
//                     className="Lender-info_column_item"
//                     valueType="phone"
//                     //name="CONTACT_PHONE"
//                     name="contact_phone"
//                     label= "PHONE #"
//                     //value={data.CONTACT_PHONE}
//                     value={data.contact_phone}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />
//                 <Input
//                     className="Lender-info_column_item"
//                     valueType="email"
//                     //name="CONTACT_EMAIL"
//                     name="contact_email"
//                     label= "EMAIL"
//                     //value={data.CONTACT_EMAIL}
//                     value={data.contact_email}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                 />
//             </div>
//         </div>
//     );
// };

// export default LenderInfo;
//#endregion

import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import Checkbox from "../CheckboxNew/Checkbox";

const LenderInfo = ({ isExists,typeDuplicate,data, handleChangeInput, handleChangeDropdown, viewMode, deleted, handleParentDropdownChange,theme = 'white' }) => {
    function getCompanyZIP()
    {
        // if(viewMode == true && typeof data.COMPANY_ZIP !== 'undefined' && data.COMPANY_ZIP != null && data.COMPANY_ZIP.length < 5)
        //     {
        //         data.COMPANY_ZIP = '0'.repeat(5 - data.COMPANY_ZIP.length) + data.COMPANY_ZIP
        //     }
        //     if(data.COMPANY_ZIP == null || data.COMPANY_ZIP == '00000' || data.COMPANY_ZIP == '')
        //     {
        //         data.COMPANY_ZIP = ''
        //     }
        //     return data.COMPANY_ZIP;
        if(viewMode == true && typeof data.zip !== 'undefined' && data.zip != null && data.zip.length < 5)
        {
            data.zip = '0'.repeat(5 - data.zip.length) + data.zip
        }
        if(data.zip == null || data.zip == '00000' || data.zip == '')
        {
            data.zip = ''
        }
        return data.zip;
    }
    return (
      <div className="Lender-info">
        <div className="Lender-info_column">
        {(isExists) && <p className="errorText">{typeDuplicate ? typeDuplicate : " Given Lender Details Already Exists"}</p>}
        <div className="hotlist_name_section">
          <div className="Lender-info_column_hotlist_name_label">
            <label>COMPANY</label>
            <Checkbox 
              text="AthCap - Hot List"
              type={viewMode ? "uncheckable" : "checkable"}
              isSelected={data.hsc_hot_list === "1"} 
              handleClick={() => handleChangeInput("hsc_hot_list")} 
              name="hsc_hot_list"
              viewMode={viewMode}
            />
          </div>
          <Input
            className="Lender-info_column_item"
            required
            valueType="text"
            //name="NAME"
            name="name"
            //label="Company"
            //value={data.NAME}
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />

          </div> 
          {/* <Input
                    className="Lender-info_column_item"
                    valueType="text"
                    //name="CITY"
                    name="city"
                    label="CITY"
                    //value={data.CITY}
                    value={data.city}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />

                <Dropdown
                    className="Lender-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    // value={data.STATE}
                    // valueKey="STATE"
                    value={data.state}
                    valueKey="state"
                    label="STATE"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}
          <Input
            className="Lender-info_column_item"
            valueType="text"
            //name="CONTACT_NAME"
            name="first_name"
            label="FIRST NAME"
            //value={data.CONTACT_NAME}
            value={data.first_name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
            required={
              data.contact_type &&
              ["Team", "Investor", "Agent"].some((type) =>
                data.contact_type.includes(type)
              )
            }
          />
          <Input
            className="Lender-info_column_item"
            valueType="text"
            //name="CONTACT_NAME"
            name="last_name"
            label="LAST NAME"
            //value={data.CONTACT_NAME}
            value={data.last_name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
            required={
              data.contact_type &&
              ["Team", "Investor", "Agent"].some((type) =>
                data.contact_type.includes(type)
              )
            }
          />
          <Input
            className="Lender-info_column_item"
            valueType="phone"
            //name="CONTACT_PHONE"
            name="contact_phone"
            label= "Work PHONE"
            //value={data.CONTACT_PHONE}
            value={data.contact_phone}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          <Input
          className="Lender-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
          {/* <Input
            className="Lender-info_column_item"
            valueType="email"
            //name="CONTACT_EMAIL"
            name="contact_email"
            label= "EMAIL"
            //value={data.CONTACT_EMAIL}
            value={data.contact_email}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
            required={data.contact_type && data.contact_type.includes("Team")}
          /> */}
          <Input
            className="Lender-info_column_item"
            valueType="email"
            //name="CONTACT_EMAIL"
            name="email"
            label= "EMAIL"
            //value={data.CONTACT_EMAIL}
            value={data.email}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
            required={data.contact_type && data.contact_type.includes("Team")}
          />
          {/* <Input
            className="Lender-info_column_item"
            //name="COMPANY_ADDRESS"
            name="address"
            label="Company Address"
            //value={data.COMPANY_ADDRESS}
            value={data.address}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          /> */}
        </div>
        <div className="Lender-info_column">
          {/* <Input
                    className="Lender-info_column_item"
                    //name="COMPANY_ADDRESS"
                    name="company_address"
                    label="Company Address"
                    //value={data.COMPANY_ADDRESS}
                    value={data.company_address}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}
          {/* <Input
            className="Lender-info_column_item"
            valueType="text"
            //name="CITY"
            name="city"
            label="CITY"
            //value={data.CITY}
            value={data.city}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          <Dropdown
            className="Lender-info_column_item"
            data={data}
            optionsType="states"
            optionKey="abbr"
            optionLabelKey="name"
            // value={data.STATE}
            // valueKey="STATE"
            value={data.state}
            valueKey="state"
            label="STATE"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
          />
          <Input
            className="Lender-info_column_item"
            //name="COMPANY_ZIP"
            name="zip"
            label="Zip"
            value={getCompanyZIP()}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          /> */}
          <Dropdown
            className="Lender-info_column_item"
            theme={theme}
            dropdownType="multiple"
            optionsType="contactType"
            value={
              Array.isArray(data.contact_type)
                ? data.contact_type.join(",")
                : data.contact_type || ""
            }
            valueKey="contact_type"
            label="Contact Type"
            data={data}
            viewMode={viewMode}
            handleParentChange={handleParentDropdownChange}
            deleted={deleted}
          />
          {/* {data.contact_type &&
            (Array.isArray(data.contact_type)
              ? data.contact_type.some((type) =>
                  type.split(",").includes("Team")
                )
              : data.contact_type.split(",").includes("Team")) && (
              <Input
                className="Agent-info_column_item"
                required
                valueType="phone"
                name="cell_phone"
                label="Cell Phone"
                value={data.cell_phone}
                handleParentChange={handleChangeInput}
                viewMode={viewMode}
                deleted={deleted}
              />
            )} */}
          {/* {data.contact_type && (data.contact_type.includes("Agent") || data.contact_type.includes("Seler") || data.contact_type.includes("Buyer") || data.contact_type.includes("Team"))  ? 
                  <Input
                  className="Lender-info_column_item"
                  required
                  valueType="text"
                  name="first_name"
                  label="First Name"
                  value={data.first_name}
                  handleParentChange={handleChangeInput}
                  viewMode={viewMode}
                  deleted={deleted} />
                  :""}
                   {data.contact_type && (data.contact_type.includes("Agent") || data.contact_type.includes("Seler") || data.contact_type.includes("Buyer") || data.contact_type.includes("Team"))  ? 
                  <Input
                    className="Lender-info_column_item"
                    required
                    valueType="text"
                    name="last_name"
                    label="Last Name"
                    value={data.last_name}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                    
                     :""} 
                */}
        </div>
      </div>
    );
};

export default LenderInfo;
